// initial state
const baseName = '/admin/api/config'

const configGroup = baseName + '/group'
const configUpdate = baseName + '/updateGroup'
const HeadCategorynotPagelist = '/admin/api/HeadCategory/notPagelist'

const a = Object.assign({configGroup, configUpdate,HeadCategorynotPagelist})
export default a
